'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var produce = require('immer');
var classNames = require('classnames');
var Loading = require('@piconetworks/loading');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var produce__default = /*#__PURE__*/_interopDefaultLegacy(produce);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var Loading__default = /*#__PURE__*/_interopDefaultLegacy(Loading);

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

var mapSeries = _async(function () {
  var series = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var mapper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var initialPromise = arguments.length > 2 ? arguments[2] : undefined;
  initialPromise = initialPromise || new Promise(function (resolve) {
    return resolve([]);
  });
  return series.reduce(function (acc, value, index, array) {
    return _await(_catch(function () {
      return _await(acc, function (results) {
        var arrayLength = array.length;
        var valueIsFunction = value && {}.toString.call(value) === '[object Function]';
        return _await(mapper(value, index, arrayLength), function (mapperResults) {
          return _await(valueIsFunction ? value(mapperResults) : mapperResults, function (result) {
            results.push(result);
            acc = new Promise(function (resolve) {
              return resolve(results);
            });
            return acc;
          }, !valueIsFunction);
        });
      });
    }, function (error) {
      return _await(acc, function (_acc) {
        error.details = {
          results: _acc,
          value: value,
          index: index,
          array: array
        };
        throw error;
      });
    }));
  }, initialPromise);
});

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

var actions = {
  CHANGE_COMPLETION_STATUS: 'CHANGE_COMPLETION_STATUS'
};

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

var init = function init(conditions) {
  var initialState = Object.keys(conditions).reduce(function (acc, key) {
    var _conditions$key = conditions[key];
        _conditions$key.Component;
        var rest = _objectWithoutProperties(_conditions$key, ["Component"]);

    acc[key] = rest;
    return acc;
  }, {});
  return initialState;
};

function _empty() {}

var spreadObjectOnState = function spreadObjectOnState(obj, immerDraftBase) {
  Object.entries(obj).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        index = _ref2[0],
        value = _ref2[1];

    if (_typeof(value) === 'object' && value !== null) {
      spreadObjectOnState(value, immerDraftBase);
    } else {
      immerDraftBase[index] = value;
    }
  });
};

function _continueIgnored(value) {
  if (value && value.then) {
    return value.then(_empty);
  }
}

var reducer = function reducer(state, _ref3) {
  var type = _ref3.type,
      payload = _ref3.payload;
  return produce__default['default'](state, function (draftState) {
    payload.condition;
        payload.isComplete;
        var rest = _objectWithoutProperties(payload, ["condition", "isComplete"]);

    switch (type) {
      case actions.CHANGE_COMPLETION_STATUS:
        draftState[payload.condition].isComplete = payload.isComplete;
        draftState[payload.condition].payload = JSON.stringify(rest);
        spreadObjectOnState(rest, draftState[payload.condition]);
        break;

      default:
        throw new Error();
    }
  });
};

var selectors = {
  canSubmit: function canSubmit(state) {
    return Object.values(state).reduce(function (acc, val) {
      if (acc === false) {
        return false;
      }

      if (val.required && val.isComplete === false) {
        return false;
      }

      return acc;
    }, true);
  },
  payload: function payload(state, conditions) {
    var conditionKeys = Object.keys(conditions);
    return conditionKeys.reduce(function (conditions, condition) {
      var _state$condition;

      conditions[condition] = JSON.parse(((_state$condition = state[condition]) === null || _state$condition === void 0 ? void 0 : _state$condition.payload) || '{}');
      return conditions;
    }, {});
  }
};
var ConditionsForm = {
  types: {
    IS_SUBMITTING: 'IS_SUBMITTING',
    SET_ERROR_MESSAGE: 'SET_ERROR_MESSAGE',
    RESET: 'RESET',
    SUBMIT_SUCCEEDED: 'SUBMIT_SUCCEEDED'
  },
  creators: {
    setIsSubmitting: function setIsSubmitting(isSubmitting) {
      return {
        type: ConditionsForm.types.IS_SUBMITTING,
        payload: {
          isSubmitting: isSubmitting
        }
      };
    },
    setErrorMessage: function setErrorMessage(errorMessage) {
      return {
        type: ConditionsForm.types.SET_ERROR_MESSAGE,
        payload: {
          errorMessage: errorMessage
        }
      };
    },
    reset: function reset(payload) {
      return {
        type: ConditionsForm.types.RESET,
        payload: payload
      };
    },
    setSubmitSucceeded: function setSubmitSucceeded(payload) {
      return {
        type: ConditionsForm.types.SUBMIT_SUCCEEDED,
        payload: payload
      };
    }
  },
  initialState: {
    errorMessage: null,
    isSubmitting: false,
    submitSucceeded: false
  },
  reducer: function reducer(state, _ref4) {
    var type = _ref4.type,
        payload = _ref4.payload;
    return produce__default['default'](state, function (draftState) {
      switch (type) {
        case ConditionsForm.types.IS_SUBMITTING:
          draftState.isSubmitting = payload.isSubmitting;
          break;

        case ConditionsForm.types.SET_ERROR_MESSAGE:
          draftState.errorMessage = payload === null || payload === void 0 ? void 0 : payload.errorMessage;
          break;

        case ConditionsForm.types.SUBMIT_SUCCEEDED:
          draftState.submitSucceeded = true;
          break;

        case ConditionsForm.types.RESET:
          console.log('reset');
          spreadObjectOnState(ConditionsForm.initialState, draftState);
          break;

        default:
          throw new Error();
      }
    });
  },
  selectors: {
    isSubmitting: function isSubmitting(state) {
      return state === null || state === void 0 ? void 0 : state.isSubmitting;
    },
    errorMessage: function errorMessage(state) {
      return state === null || state === void 0 ? void 0 : state.errorMessage;
    },
    submitSucceeded: function submitSucceeded(state) {
      return state === null || state === void 0 ? void 0 : state.submitSucceeded;
    }
  },
  mapStateToProps: function mapStateToProps(state) {
    return {
      isSubmitting: ConditionsForm.selectors.isSubmitting(state),
      errorMessage: ConditionsForm.selectors.errorMessage(state),
      submitSucceeded: ConditionsForm.selectors.submitSucceeded(state)
    };
  },
  mapDispatchToProps: function mapDispatchToProps(dispatch) {
    return {
      setIsSubmitting: function setIsSubmitting(payload) {
        return dispatch(ConditionsForm.creators.setIsSubmitting(payload));
      },
      setErrorMessage: function setErrorMessage(payload) {
        return dispatch(ConditionsForm.creators.setErrorMessage(payload));
      },
      setSubmitSucceeded: function setSubmitSucceeded(payload) {
        return dispatch(ConditionsForm.creators.setSubmitSucceeded(payload));
      },
      reset: function reset(payload) {
        return dispatch(ConditionsForm.creators.reset(payload));
      }
    };
  }
};

var useConnectedModule = function useConnectedModule(module, ownProps) {
  var _useReducer = React.useReducer(module.reducer, module.initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var defaults = {
    mapStateToProps: function mapStateToProps() {
      return {};
    },
    mapDispatchToProps: function mapDispatchToProps() {
      return {};
    },
    mergeProps: function mergeProps(stateProps, dispatchProps, ownProps) {
      return Object.assign({}, ownProps, stateProps, dispatchProps);
    }
  };
  var mapStateToProps = module.mapStateToProps || defaults.mapStateToProps;
  var mapDispatchToProps = module.mapDispatchToProps || defaults.mapDispatchToProps;
  var mergeProps = module.mergeProps || defaults.mergeProps;
  var stateProps = mapStateToProps(state, ownProps);
  var dispatchProps = mapDispatchToProps(dispatch, ownProps);
  return mergeProps(stateProps, dispatchProps, ownProps);
};

var ConditionAggregator = function ConditionAggregator(_ref5) {
  var conditions = _ref5.conditions,
      onSubmit = _ref5.onSubmit,
      Submit = _ref5.Submit,
      Form = _ref5.Form,
      globalPostSubmit = _ref5.postSubmit;
  var formRef = React.useRef(null);
  var conditionsForm = useConnectedModule(ConditionsForm);

  var _useReducer3 = React.useReducer(reducer, conditions, init),
      _useReducer4 = _slicedToArray(_useReducer3, 2),
      state = _useReducer4[0],
      dispatch = _useReducer4[1];

  var submitDisabled = !selectors.canSubmit(state) || conditionsForm.isSubmitting;
  var sections = Object.entries(conditions).map(function (_ref6) {
    var _state$key;

    var _ref7 = _slicedToArray(_ref6, 2),
        key = _ref7[0],
        _ref7$ = _ref7[1],
        Component = _ref7$.Component,
        _ref7$$requires = _ref7$.requires,
        requires = _ref7$$requires === void 0 ? [] : _ref7$$requires;

    return /*#__PURE__*/React__default['default'].createElement(Component, {
      key: key,
      changeCompletionStatus: function changeCompletionStatus(payload) {
        return _await(mapSeries(requires, function () {
          return state;
        }), function (requirements) {
          var requirementsSatisfied = requirements.every(function (requirement) {
            return requirement === true;
          });

          if (!requirementsSatisfied) {
            return false;
          }

          dispatch({
            type: actions.CHANGE_COMPLETION_STATUS,
            payload: Object.assign({}, payload, {
              condition: key
            })
          });
        });
      },
      isComplete: (_state$key = state[key]) === null || _state$key === void 0 ? void 0 : _state$key.isComplete,
      submitConditionAggregator: function submitConditionAggregator() {
        if (!conditionsForm.isSubmitting) {
          var _formRef$current;

          formRef === null || formRef === void 0 ? void 0 : (_formRef$current = formRef.current) === null || _formRef$current === void 0 ? void 0 : _formRef$current.dispatchEvent(new Event('submit', {
            cancelable: true
          }));
        }
      },
      errorMessage: conditionsForm.errorMessage,
      stateProps: state[key],
      payloads: selectors.payload(state, conditions),
      conditionAggregatorState: state
    });
  });
  return /*#__PURE__*/React__default['default'].createElement(Form, {
    formRef: formRef,
    onSubmit: _async(function (event) {
      event.preventDefault();

      if (conditionsForm.isSubmitting) {
        return null;
      }

      conditionsForm.reset();
      return _continueIgnored(_catch(function () {
        conditionsForm.setIsSubmitting(true);
        var preSubmitHooks = Object.entries(conditions).filter(function (_ref8) {
          var _ref9 = _slicedToArray(_ref8, 2),
              key = _ref9[0],
              preSubmit = _ref9[1].preSubmit;

          return !!preSubmit;
        });
        var postSubmitHooks = Object.entries(conditions).filter(function (_ref10) {
          var _ref11 = _slicedToArray(_ref10, 2),
              key = _ref11[0],
              postSubmit = _ref11[1].postSubmit;

          return !!postSubmit;
        });
        var preSubmits = preSubmitHooks.map(function (_ref12) {
          var _ref13 = _slicedToArray(_ref12, 2),
              key = _ref13[0],
              preSubmit = _ref13[1].preSubmit;

          return preSubmit;
        });
        var postSubmits = postSubmitHooks.map(function (_ref14) {
          var _ref15 = _slicedToArray(_ref14, 2),
              key = _ref15[0],
              postSubmit = _ref15[1].postSubmit;

          return postSubmit;
        });
        var preSubmitHookKeys = preSubmitHooks.map(function (_ref16) {
          var _ref17 = _slicedToArray(_ref16, 1),
              key = _ref17[0];

          return key;
        });
        return _await(mapSeries(preSubmits, function () {
          return {
            conditions: conditions,
            state: state,
            payloads: selectors.payload(state, conditions)
          };
        }), function (preSubmitHookValues) {
          var preSubmitHookResults = preSubmitHookKeys.reduce(function (obj, key, index) {
            return Object.assign({}, obj, _defineProperty({}, key, preSubmitHookValues[index]));
          }, {});
          return _await(onSubmit(event, {
            conditions: conditions,
            state: state,
            preSubmitHookResults: preSubmitHookResults,
            payloads: selectors.payload(state, conditions)
          }), function (submitResults) {
            return _await(mapSeries(postSubmits), function (postSubmitHookResults) {
              return _await(globalPostSubmit({
                submitResults: submitResults,
                postSubmitHookResults: postSubmitHookResults,
                payloads: selectors.payload(state, conditions)
              }), function () {
                conditionsForm.setIsSubmitting(false);
                conditionsForm.setSubmitSucceeded();
              });
            });
          });
        });
      }, function (error) {
        conditionsForm.setIsSubmitting(false);
        conditionsForm.setErrorMessage(error.message);
      }));
    })
  }, sections, conditionsForm.submitSucceeded && /*#__PURE__*/React__default['default'].createElement(Loading__default['default'], null), conditionsForm.submitSucceeded, conditionsForm.errorMessage && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "errorContainer"
  }, conditionsForm.errorMessage), /*#__PURE__*/React__default['default'].createElement(Submit, {
    disabled: submitDisabled,
    isSubmitting: conditionsForm.isSubmitting,
    submitConditionAggregator: function submitConditionAggregator() {
      if (!conditionsForm.isSubmitting) {
        var _formRef$current2;

        formRef === null || formRef === void 0 ? void 0 : (_formRef$current2 = formRef.current) === null || _formRef$current2 === void 0 ? void 0 : _formRef$current2.dispatchEvent(new Event('submit'));
      }
    }
  }));
};
ConditionAggregator.defaultProps = {
  conditions: [],
  Submit: function Submit(_ref18) {
    var disabled = _ref18.disabled;
        _ref18.formRef;
        var isSubmitting = _ref18.isSubmitting;
    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: isSubmitting ? 'loadingSpinner' : ''
    }, /*#__PURE__*/React__default['default'].createElement("input", {
      className: classNames__default['default']("btn btn-primary btn-block"),
      disabled: disabled,
      type: "submit",
      value: isSubmitting ? '' : 'Submit'
    }));
  },
  Form: function Form(_ref19) {
    var children = _ref19.children,
        onSubmit = _ref19.onSubmit,
        formRef = _ref19.formRef;
    return /*#__PURE__*/React__default['default'].createElement("form", _extends({
      onSubmit: onSubmit
    }, formRef && {
      ref: formRef
    }), children);
  },
  onSubmit: function onSubmit() {}
};
ConditionAggregator.propTypes = {
  conditions: PropTypes__default['default'].object,
  Submit: PropTypes__default['default'].func,
  Form: PropTypes__default['default'].func,
  onSubmit: PropTypes__default['default'].func
};

module.exports = ConditionAggregator;
